import usePageMeta from "@/lib/usePageMeta";
import Hero from "@/components/home/Hero";
import Marquee from "@/components/Marquee";
import Stats from "@/components/home/Stats";
import AboutSection from "@/components/home/AboutSection";
import ServicesSection from "@/components/home/ServicesSection";
import WhySection from "@/components/home/WhySection";
import ProcessSection from "@/components/home/ProcessSection";
import IndustriesSection from "@/components/home/IndustriesSection";
import EngageSection from "@/components/home/EngageSection";
import SplitCTA from "@/components/home/SplitCTA";
import FAQ from "@/components/home/FAQ";

export default function Home() {
  usePageMeta(
    "Talentify | Recruitment Agency in India — IT & Non-IT Talent Acquisition, PAN India",
    "Talentify delivers specialised IT and Non-IT recruitment solutions across India — leadership hiring, volume hiring and end-to-end recruitment support for MNCs, startups and growing businesses."
  );
  return (
    <main>
      <Hero />
      <Marquee />
      <Stats />
      <AboutSection />
      <ServicesSection />
      <WhySection />
      <ProcessSection />
      <IndustriesSection />
      <EngageSection />
      <SplitCTA />
      <FAQ />
    </main>
  );
}
